<template>
    <el-row :gutter="20" class="main_block">
        <div class="mianContent">
            <div class="tagView">
                <div class="title_aside"></div>
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item>{{
                        $route.meta.title
                    }}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div>
                <div class="fifter">
                    <el-row>
                        <el-col :span="20">
                            <el-form
                                :model="searchParam"
                                status-icon
                                ref="searchData"
                                label-position="left"
                                label-width="90px"
                                :inline="true"
                            >
                                <el-form-item label="">
                                    <el-date-picker
                                        v-model="dateval"
                                        type="daterange"
                                        range-separator="至"
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期"
                                        @change="datetime"
                                        format="yyyy-MM-dd"
                                        value-format="timestamp"
                                    ></el-date-picker>
                                </el-form-item>
                                <el-form-item label="">
                                    <el-input
                                        type="text"
                                        v-model="orderNo"
                                        autocomplete="off"
                                        placeholder="请输入订单号"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label="">
                                    <el-button
                                        type="primary"
                                        @click="selectfifter"
                                        >查询</el-button
                                    >
                                </el-form-item>
                            </el-form>
                            <!-- 申请时间：
                            <el-date-picker
                                v-model="dateval"
                                type="daterange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                @change="datetime"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                            ></el-date-picker>
                            订单号：
                            <el-input
                                type="text"
                                v-model="orderNo"
                                autocomplete="off"
                                placeholder="请输入订单号"
                            ></el-input>
                            <el-button type="primary" plain @click="selectfifter" style="margin-left:10px">查询</el-button> -->
                        </el-col>
                    </el-row>
                </div>
                <div class="table">
                    <ul class="th">
                        <li class="td">发票信息</li>
                        <li class="td">投递信息</li>
                        <li class="td center">开票金额</li>
                        <li class="td center">状态</li>
                        <li class="td center">快递信息</li>
                        <li class="td center">操作</li>
                    </ul>
                    <div class="list-item" v-for="tableitem in tableData" :key="tableitem.id">
                        <ul class="tr">
                            <li class="td">
                                <dl>
                                    <dt>发票类型：</dt>
                                    <dd>
                                        {{tableitem.typeValue}}
                                    </dd>
                                </dl>
                                <dl>
                                    <dt>发票类别：</dt>
                                    <dd v-if="tableitem.category==0 || tableitem.category==3">增值税普通发票</dd>
                                    <dd v-else>增值税专用发票</dd>
                                </dl>
                                <dl>
                                    <dt>发票抬头：</dt>
                                    <!-- <dd v-if="tableitem.title=='1'">
                                        个人
                                    </dd> -->
                                    <dd>
                                        {{tableitem.subjectName}}
                                    </dd>
                                </dl>
                                <dl v-if="tableitem.subjectType==1">
                                    <dt>税号：</dt>
                                    <dd>{{tableitem.uscc}}</dd>
                                </dl>
                                <dl v-if="tableitem.bankName || tableitem.bankNo">
                                    <dt>开户行及账号：</dt>
                                    <dd>{{tableitem.bankName}}{{tableitem.bankNo}}</dd>
                                </dl>
                                <dl v-if="tableitem.entAddress">
                                    <dt>地址：</dt>
                                    <dd>{{tableitem.entAddress}}</dd>
                                </dl>
                                <dl v-if="tableitem.entPhone">
                                    <dt>电话：</dt>
                                    <dd>{{tableitem.entPhone}}</dd>
                                </dl>
                            </li>
                            <li class="td">
                                <!-- <dl v-if="tableitem.type==0">
                                    <dt>邮编：</dt>
                                    <dd>{{tableitem.postalCode}}</dd>
                                </dl> -->
                                <dl v-if="tableitem.email">
                                    <dt>接收邮箱：</dt>
                                    <dd>{{tableitem.email}}</dd>
                                </dl>
                                <dl v-if="tableitem.type==0">
                                    <dt>收件人姓名：</dt>
                                    <dd>{{tableitem.receiver}}</dd>
                                </dl>
                                <dl v-if="tableitem.mobile">
                                    <dt>手机号：</dt>
                                    <dd>{{tableitem.mobile}}</dd>
                                </dl>
                                <dl v-if="tableitem.type==0">
                                    <dt>收件详细地址：</dt>
                                    <dd>
                                        {{tableitem.province}}
                                        {{tableitem.city}}
                                        {{tableitem.district}}
                                        {{tableitem.address}}
                                    </dd>
                                </dl>
                            </li>
                            <li class="td center">
                                <span>{{parseFloat(tableitem.amount).toFixed(2)}}元</span>
                            </li>
                            <li class="td center">
                                <div class="center" v-if="tableitem.type==0">
                                    <!-- 纸质 -->
                                    <template>
                                        <span v-if="tableitem.invoiceStatus==0" style="color:#409EFF">待审核</span>
                                        <span v-if="tableitem.invoiceStatus==1" style="color:#409EFF">待开票</span>
                                        <span v-if="tableitem.invoiceStatus==2" style="color:#409EFF">未邮寄</span>
                                        <span v-if="tableitem.invoiceStatus==3" style="color:#409EFF">已邮寄</span>
                                        <span v-if="tableitem.invoiceStatus==4" style="color:#409EFF">已作废</span>
                                        <span v-if="tableitem.invoiceStatus==5" style="color:#409EFF">已冲红</span>
                                        <span v-if="tableitem.invoiceStatus==7" style="color:#409EFF">发送失败</span>
                                        <span v-if="tableitem.invoiceStatus==8" style="color:#409EFF">重开审核中</span>
                                        <span v-if="tableitem.invoiceStatus==12" style="color:#409EFF">重开已拒绝</span>
                                        <span v-if="tableitem.invoiceStatus==13" style="color:#409EFF">待寄回</span>
                                    </template>
                                </div>
                                <div class="center" v-if="tableitem.type==2 || tableitem.type==1">
                                    <!-- 电子 -->
                                    <template>
                                        <span v-if="tableitem.invoiceStatus==14" style="color:#409EFF">开票中</span>
                                        <span v-if="tableitem.invoiceStatus==15" style="color:#409EFF">已开票</span>
                                        <span v-if="tableitem.invoiceStatus==7" style="color:#409EFF">发送失败</span>
                                        <span v-if="tableitem.invoiceStatus==4" style="color:#409EFF">已作废</span>
                                        <span v-if="tableitem.invoiceStatus==8" style="color:#409EFF">重开审核中</span>
                                        <span v-if="tableitem.invoiceStatus==12" style="color:#409EFF">重开已拒绝</span>
                                    </template>
                                </div>
                            </li>
                            <li class="td">
                                <template v-if="(tableitem.type==0)&&!([0,1,2].includes(tableitem.invoiceStatus))">
                                    <dl>
                                        <dt>快递公司：</dt>
                                        <dd>{{tableitem.expressCompany}}</dd>
                                    </dl>
                                    <dl>
                                        <dt>快递单号：</dt>
                                        <dd>{{tableitem.trackingNumber}}</dd>
                                    </dl>
                                </template>
                            </li>
                            <li class="td operation">
                                <a v-if="tableitem.pdfUrl && !([4,14,8].includes(tableitem.invoiceStatus))" class="btn" :href="tableitem.pdfUrl" target="_blank">查看发票</a>
                                <!-- 发送失败和电子票-已开票和重开已拒绝状态，建议增加【重新发送】按钮。 -->
                                <span class="btn" v-if="(((tableitem.type==1 || tableitem.type==2) && (tableitem.invoiceStatus==15 || tableitem.invoiceStatus==12 || tableitem.invoiceStatus==7 || tableitem.invoiceStatus==12)))" @click="sendAgain(tableitem)">重新发送</span>
                                <span class="btn" :class="{ disabled: downloading }" v-if="[15].includes(tableitem.invoiceStatus) || (tableitem.invoiceStatus==12 && tableitem.type!==0)" @click="downloadInvoice(tableitem)">下载发票</span>
                                <a class="btn" v-if="[3,12,15].includes(tableitem.invoiceStatus)" @click="restart(tableitem)">申请重开</a>
                                <span class="btn" v-if="tableitem.type==0 && [13].includes(tableitem.invoiceStatus)" @click="openAddress">查看地址</span>
                            </li>
                        </ul>
                        <ul class="tr">
                            <li class="td tdbot">
                                <p>申请时间：{{tableitem.createdAt | formatDate}}</p>
                                <div class="ordernum">
                                    备注：
                                    <div class="orderlist">
                                        {{tableitem.invoiceRemark}}
                                    </div>
                                </div>
                                <div class="ordernum">
                                    订单号：
                                    <div class="orderlist">
                                        <div v-if="tableitem.orderIds">
                                            <span v-for="orderid in tableitem.orderIds.split(',')" :key="orderid" >{{orderid}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="ordernum" v-if="tableitem.reason && [12].includes(tableitem.invoiceStatus)">
                                    拒绝原因：
                                    <div class="orderlist">
                                        {{tableitem.reason}}
                                    </div>
                                </div>
                                
                            </li>
                        </ul>
                    </div>
                    <div class="noorder" v-if="tableData.length==0">
                        <div>
                            <img src="@/assets/images/noorder.png" alt="">
                            <br>
                            <span>暂无开票历史</span>
                        </div>
                    </div>
                </div>
                <div class="page">
                    <el-pagination
                        @current-change="clickpage"
                        :current-page="currentPage"
                        :total="totalCount"
                        :page-size="pageSize"
                        background
                        layout="total, prev, pager, next, jumper"
                    >
                    </el-pagination>
                </div>
            </div>
        </div>
        <el-dialog
            title="重新发送"
            :visible.sync="sendAgainDia"
            width="612px"
            class="sendAgainDia"
            :close-on-press-escape="false"
            :close-on-click-modal="false"
            center
            @close="closeDia"
        >
            <p>注：接收邮箱和收件人电话至少输入一个才可以重新发送</p>
            <el-form :model="sendAgainForm" status-icon :rules="rules" ref="sendAgainForm" label-width="100px" class="sendAgainForm">
                <el-form-item label="接收邮箱" prop="email">
                    <el-input type="text" v-model="sendAgainForm.email" autocomplete="off" placeholder="请输入接收邮箱"></el-input>
                </el-form-item>
                <el-form-item label="收件人电话" prop="mobile">
                    <el-input type="text" v-model="sendAgainForm.mobile" autocomplete="off" placeholder="请输入收件人电话"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeDia">取 消</el-button>
                <el-button type="primary" @click="submitDialogForm('sendAgainForm')">确 定</el-button>
            </span>

        </el-dialog>
        <div id="captcha-element"></div>
        <InvoiceDialog
            :visible.sync="restartDialogVisible"
            title="申请重开"
            width="600px"
            @confirm="onRestartConfirm"
            @cancel="onRestartCancel"
            @close="onRestartCancel"
        >
            <div class="dialog-form-body">
                <InvoiceRestart ref="invoiceRestart" @change="onRestartTypeChange" />
            </div>
        </InvoiceDialog>
        <InvoiceDialog :visible.sync="sendVisible" title="申请已提交" width="438px" type="simple" @confirm="onConfirm">
            <div class="dialog-simple-body">
                <p class="ts">您提交的申请将由人工进行审核，请及时关注开票历史中的审核状态。释放订单后原发票将被作废，无法进行报销。</p>
            </div>
        </InvoiceDialog>

        <InvoiceDialog :visible.sync="addressDialogVisible" title="提示" width="438px" type="simple" confirmText="我知道了" @confirm="addressDialogVisible = false">
            <div class="dialog-simple-body address-body">
                <p class="ts address-text">请将旧发票寄回下面的地址（邮费自理，不接受货到付款），客服将在收到发票后为您开具新的发票或释放订单</p>
                <p class="address-info">地址：北京市朝阳区酒仙桥北路甲10号电子城IT产业园204号楼五层联合信任</p>
                <p class="address-info">邮编：100015</p>
                <p class="address-info">收件人：联合信任</p>
                <p class="address-info">收件人电话：400-0186-091</p>
            </div>
        </InvoiceDialog>
    </el-row>
</template>

<script>
import {searchAppInvoiceList,resendMessage,reopen,preReopen} from "@http/invoice/index";
import { filterParams } from "@/utils/filter";
import NoTrace from '@/utils/noTrace';
import InvoiceDialog from '@/components/Invoice/dialog.vue';
import InvoiceRestart from '@/components/Invoice/restart.vue';
export default {
    data() {
        var email=(rule, value, callback) => {
            var reg = new RegExp(
                "^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+\\.){1,63}[a-z0-9]+$"
                );
            if(!value){
                callback();
            }
            if (!reg.test(value)) {
                callback(new Error("邮箱格式不正确"));
            }
            callback();
        };
        var phone= (rule, value, callback) => {
            if(!value){
                callback();
            }1
            if (!(/^1[3456789]\d{9}$/.test(value))) {
                callback(new Error("请输入正确的手机号码"));
            }
            callback();
        };
        return {
            pageSize: 5,
            currentPage: 1,
            totalCount: 0,
            tableData: [],
            dateval:null,
            searchParam:{},
            orderNo:'',
            requestdata:{
                page: 1,
                size: 5,
            },
            sendAgainDia:false,
            sendAgainForm:{
                id:'',
                email:'',
                mobile:''
            },
            rules:{
                mobile: [
                    {
                        required: false,
                        message: "请输入收票人手机号",
                        trigger: "blur"
                    },
                    { validator: phone, trigger: "blur" }
                ],
                email:[
                    {
                        required: false,
                        message: "请填写邮箱",
                        trigger: "change"
                    },
                    { validator: email, trigger: "blur" }
                ]
            },
            nvc:'',
            restartDialogVisible: false,
            restartItem: null,
            restartType: 1,
            sendVisible:false,
            downloading: false,
            addressDialogVisible: false,
        };
    },
    components: {
        InvoiceDialog,
        InvoiceRestart
    },
    created() {
        let query=this.$route.query;
        this.orderNo=query.orderNo;
        this.requestdata=Object.assign(this.requestdata,{orderIds:this.orderNo})
        this.creatrequest()
    },
    mounted() {
        NoTrace.init('captcha-element', 'captcha-button')
    },
    beforeDestroy() {
        NoTrace.reset()
    },
    methods: {
        creatrequest() {
            let that = this;
            if(!this.dateval){
                delete this.requestdata.startTime;
                delete this.requestdata.endTime;
            }
            if(!this.orderNo){
                delete this.requestdata.orderIds;
            }
            searchAppInvoiceList(that.requestdata).then(res => {
                    that.tableData = res.data;
                    that.totalCount = res.total;
            })
            .catch(err => {
                // that.$msg(err.message);
                console.log(err);
            });
        },
        datetime(e){
            this.dateval=e;
        },
        selectfifter(){
            this.requestdata.startTime=this.dateval?this.dateval[0]:'';
            this.requestdata.endTime=this.dateval?this.dateval[1]:'';
            this.requestdata.orderIds=this.orderNo;
            this.creatrequest();
        },
        clickpage(e) {
            this.requestdata.page=e;
            this.requestdata.size=this.pageSize;
            this.creatrequest();
        },
        sendAgain(item){
            this.sendAgainForm.id=item.id;
            this.sendAgainForm.email=item.email;
            this.sendAgainForm.mobile=item.mobile;
            this.sendAgainDia = true;
        },
        closeDia(){
            // NoTrace.reset();
            this.sendAgainDia = false;
        },
        submitDialogForm(formName){
            let that = this;
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    //邮箱和电话必须填其中一个，都不填提示
                    if(!this.sendAgainForm.email && !this.sendAgainForm.mobile){
                        this.$msg('请填写接收邮箱或手机号')
                        return
                    }
                    // 开始获取无痕验证码
                    NoTrace.start((nvc) => {
                        this.nvc = nvc;
                        this.sendAgainForm.nvc=nvc;
                    }, this.executeFun, {
                        ...filterParams(this.sendAgainForm),
                        afsVersion: 2
                    })
                }else {
                    console.log('error submit!!');
                    return false;
                }
            })
        },
        executeFun(params){
            let that=this;
            return new Promise(async (resolve, reject) => {
                try {
                    let res = await resendMessage(params);
                    resolve(res)
                    that.closeDia();
                    that.$msg("发送成功", "success");
                }catch (err) {
                    reject(err)
                    clearInterval(interval);
                }
            })
        },
        restart(item){
            this.restartItem = item;
            this.restartType = 1;
            this.restartDialogVisible = true;
        },
        onRestartTypeChange(val) {
            this.restartType = val;
        },
        async onRestartConfirm() {
            this.restartDialogVisible = false;
            if(this.restartType===1){
                this.$router.replace({
                    path: '/invoice/personIn',
                    query:{
                        id:this.restartItem.id
                    }
                })
            }else{
                try {
                    await preReopen(this.restartItem.id)
                    await reopen({...this.restartItem,reopenType:2})
                    this.creatrequest();
                    this.sendVisible=true;
                } catch (error) {
                    that.$msg(error.message, "error");
                }
            }
        },
        onRestartCancel() {
            this.restartDialogVisible = false;
            this.restartItem = null;
        },
        onConfirm(){
            this.sendVisible=false
        },
        downloadInvoice(item) {
            if (this.downloading) return;
            this.downloading = true;
            const firstOrderId = item.orderIds ? item.orderIds.split(',')[0] : '';
            const fileName = `${firstOrderId}可信时间戳发票.pdf`;
            fetch(item.pdfUrl)
                .then(res => res.blob())
                .then(blob => {
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.download = fileName;
                    link.style.display = 'none';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(url);
                    this.downloading = false;
                })
                .catch(() => {
                    this.$msg('下载失败，请重试', 'error');
                    this.downloading = false;
                });
        },
        openAddress(){
            this.addressDialogVisible = true;
        }
    },

};
</script>
<style scoped lang="less">
.dialog-form-body {
    padding: 24px 28px;
}
.dialog-simple-body {
    // padding: 24px 28px;
    text-align: left;
}
.address-body {
    .address-text {
        color: #F17D44;
        font-size: 14px;
        line-height: 22px;
        margin-bottom: 16px;
        text-align: left;
    }
    .address-info {
        color: #333;
        font-size: 14px;
        line-height: 28px;
        text-align: left;
    }
}
.sendAgainDia {
  .el-dialog__header {
    background: #EEEEEE;
  }

  .el-dialog__body {
    padding-bottom: 0
  }

  p {
    box-sizing: border-box;
    width: 100%;
    padding: 20px;
    background: #FFF9E1;
    color: #F17D44;
    border-radius: 10px;
  }
  .sendAgainForm{
    padding: 20px;
  }
}
</style>
<style scoped>
.wrap {
    width: 100%;
    box-sizing: border-box;
    padding: 20px;
}
.fifter{
    padding: 20px 0 0;
}
.table {
    width: 100%;
    box-sizing: border-box;
}
.table ul {
    width: 100%;
    box-sizing: border-box;
    display: -webkit-flex;
    display: flex;
    -webkit-flex-direction: row;
    flex-direction: row;
}
.table ul li{
   width: 100%; 
   box-sizing: border-box;
}
.table ul li:nth-child(1){
    -webkit-flex: 3;
    flex: 3;
}
.table ul li:nth-child(2){
    -webkit-flex: 3;
    flex: 3;
}
.table ul li:nth-child(3){
    -webkit-flex: 1;
    flex: 1;
}
.table ul li:nth-child(4){
    -webkit-flex: 1;
    flex: 1;
}
.table ul li:nth-child(5){
    -webkit-flex: 2;
    flex: 2;
}
.table ul li:nth-child(6){
    -webkit-flex:1;
    flex: 1;
    margin-right:0;
}
.th{
    background:#F2F3F8;
    line-height: 41px;
}
.tr{
    margin-top:2px; 
}
.td{
    padding: 10px;
}
.table ul li.tdbot{
    margin-right: 0;
}
.th .td{
    font-size: 14px;
    color:#333;
    font-weight: 600;
}
.tr .td{
    font-size: 12px;
    color:#7D7D7D;
    margin-right: 2px;
    background:rgba(242,243,248,.6);
}
.td dl{
    display: -webkit-flex;
    display: flex;
    -webkit-flex-direction: row;
    flex-direction: row;
    padding: 2px 0;
}
.td dl dt{
    line-height: 20px;
}
.td dl dd{
    -webkit-flex: 1;
    flex: 1;
    line-height: 20px;
}
.operation{
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
}
.btn{
    color:#409EFF;
    cursor: pointer;
    margin-bottom:10px;
    cursor: pointer;
}
.btn.disabled {
    color: #a0cfff;
    cursor: not-allowed;
}
.center{
    display: -webkit-flex;
    display: flex;
    -webkit-justify-content: center;
    justify-content: center;
}
.center span{
    align-self: center;
}
.ordernum{
    width: 100%;
    word-break: break-all;
    display: -webkit-flex;
    display: flex;
    -webkit-flex-direction: row;
    flex-direction: row;
    margin-top:5px; 
}
.ordernum span{
    display: inline-block;
    padding: 1px 10px;
    background:#fff;
    border-radius: 30px;
    margin:2px 4px;
}
.orderlist{
    -webkit-flex:1;
    flex:1;
}
.list-item{
    margin-bottom: 24px;
}
.page{
    text-align: right;
}
.noorder{
    text-align: center;
    padding: 25px 0 134px;
}
.noorder span{
    font-size: 14px;
    color:#999;
    margin-top:10px;
    display: inline-block;
}
.ts{
    line-height: 25px;
    font-size: 14px;
}
</style>
